import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const CALENDLY_FALLBACK = "https://calendly.com/swiles-sideb/30min";

/**
 * Legacy /book/:serviceId route — kept for backward-compatible email/footer
 * links. Looks up the service's booking URL (Calendly) and hard-redirects
 * the browser. No internal intake form anymore — Calendly owns the flow.
 */
export default function BookingFlow() {
  const { serviceId } = useParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get("/services")
      .then((r) => {
        const match = r.data.find((s) => s.id === serviceId || s.sku === serviceId);
        const url = match?.google_calendar_url || CALENDLY_FALLBACK;
        window.location.replace(url);
      })
      .catch(() => {
        // If the catalog fetch fails (offline / 5xx), fall back to the
        // universal Calendly link so the user still completes their booking.
        window.location.replace(CALENDLY_FALLBACK);
      })
      .finally(() => setStatus("redirected"));
  }, [serviceId]);

  if (status === "redirected") return <Navigate to="/services" replace />;
  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="booking-redirect">
      <div className="label-mono">Redirecting</div>
      <h1 className="font-display text-3xl mt-2 tracking-tight">Opening Calendly…</h1>
      <p className="text-muted-foreground mt-3 text-sm">If you aren&apos;t redirected,{" "}
        <a href={CALENDLY_FALLBACK} className="text-[#ac62ea] hover:underline" target="_blank" rel="noopener noreferrer">click here</a>.
      </p>
    </div>
  );
}
